import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";

/**
 * query the s3 key of an audio file associated with the appointment
 */
export default async function queryRecordingS3Key(appointmentId: string) {
  const res = await fetchOrchidAPI(
    `/api/scheduler/v1/transcription/appointment/${appointmentId}/recording_s3_key`,
  );

  if (!res.ok) {
    throw new Error(
      `failed to get s3 key: ${getErrorDetail(await res.text())}`,
    );
  }

  return res.json();
}
